export default function (chart) {
  chart.center = ['50%', '50%'];
  chart.radius = ['0', '70%'];
  chart.label = {
    normal: {
      show: false
    }
  };
  chart.labelLine = {
    normal: {
      show: false
    }
  };
}